import axios from "axios";

export function getDisplayErrorMessage(
  error: unknown,
  fallback: string = "Something went wrong."
): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;

    // ✅ case: string response
    if (typeof data === "string") {
      return data;
    }

    // ✅ case: object with message
    if (typeof data === "object" && data !== null) {
      const msg = (data as any).message || (data as any).Message;
      if (typeof msg === "string") {
        return msg;
      }
    }

    // ❗ case: not string → fallback
    return fallback;
  }

  // ✅ normal JS error
  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
}